module.exports = __webpack_public_path__ + "63f52716b27d543067e8ba7cdce260af.jpg";